import { IDialogConfig } from './index'

export let bridge: {
  setConfig?: (isOpen: boolean, config: IDialogConfig) => any
} = {}

// 暴露给用户调用的方法
export function openDialog(config: IDialogConfig) {
  if (bridge.setConfig) {
    bridge.setConfig(true, {
      closeOnClickMask: true,//没有设置的话，默认点击遮罩层可以关闭
      ...config
    })
  }
}

// 暴露给用户调用的方法
export function closeDialog() {
  if (bridge.setConfig) {
    bridge.setConfig(false, { })
  }
}

export const defaultConfig = {
  title: '',
  content: '',
  buttonArray: []
}



// WEBPACK FOOTER //
// ../src/popup-layer/dialog/bridge.ts